import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";

import { CategoryForm } from "../components";
import { useCategory, useUpdateCategory } from "../hooks";

type IUpdateScan = {
  id: string;
};

export const UpdateCategory: React.FC = () => {
  const { id } = useParams<IUpdateScan>();
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useCategory(+id!);
  const { form, submit, loading } = useUpdateCategory({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("La categorie a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.category?.ok && data?.category?.result) {
      form.setValue("name", data.category?.result?.name);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }
  return (
    <>
      <Header
        title="Catégorie"
        subtitle="Modifier la catégorie"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: "/categories",
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="w-full">
          <div className="card">
            <CategoryForm loading={loading} submit={submit} form={form} />
          </div>
        </div>
      </div>
    </>
  );
};
